<template>
  <el-dialog :title="title" :visible.sync="dialogFormVisible"   style="width:400px;margin:auto;" @close="close" :close-on-click-modal="false">
    <el-form ref="form" :model="form" :rules="rules" label-width="90px"  v-loading="loading" :element-loading-text="elementLoadingText">
        <el-row>
          <el-col :span="24">
            <div class="el-form-item is-required">
              <label for="mobile" class="el-form-item__label" style="width: 100px;">退款原因：</label>
              <div class="el-form-item__content" style="margin-left: 100px;">
                <div class="el-input">
                   <select v-model="form.reason"  class="refundReason">
                    <option v-for="(item,index) in refundReasons" :key="index" :value="item.reason">{{item.reason}}</option>
                   </select>
                </div>
              </div>
            </div>
            <div class="el-form-item">
              <label for="mobile" class="el-form-item__label" style="width: 100px;">退款说明：</label>
              <div class="el-form-item__content" style="margin-left: 100px;">
                <div class="el-input">
                  <textarea v-model="form.description" rows="3" class="refundDescription"></textarea>
                </div>
              </div>
            </div>
          </el-col>   
        </el-row>   
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button class="closeBtn"  @click="close">取 消</el-button>
      <el-button class="saveBtn" type="primary" @click="validateData">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import store from '@/store'
import { refund, getRefundReasons } from '@/api/order'
import axios from 'axios'
export default {
  name: 'OrderRefund',
  components: {  },
  data() {
    return {     
      form: { 
        orderId:0,
        reason:'',
        description:'',
        refundAmount:'',
        vouchers:'',
      },
      rules: { },  
      codeUrl:'',
      title: '',
      dialogFormVisible: false,
      loading:false,
      elementLoadingText:"数据提交中,请稍后...",     
      refundReasons:[],   
    }
  },
  methods: {
    async showRefund(row) {  
      this.title = '申请退款'     
      this.form.orderId = row.id;
      this.form.refundAmount = row.realAmount;
      await getRefundReasons({refundType:0}).then(res=>{
        this.refundReasons = res.data.result;
        if(this.refundReasons&&this.refundReasons.length>0)
        {
          this.form.reason = this.refundReasons[0].reason;
        }
      });

      this.dialogFormVisible = true;
    },     
    
    close() {    
      this.$refs['form'].resetFields()
      this.$emit('fetch-data')
      this.form = this.$options.data().form      
      this.dialogFormVisible = false
    },
    validateData()
    {
      if(this.form.orderId==null||this.form.orderId==0||this.form.orderId==undefined)
      {
        this.$message.error('未能找到退款的订单!')
        return
      }     
      if(this.form.refundAmount==null||this.form.refundAmount==''||this.form.refundAmount==undefined)
      {
        this.$message.error('未能找到退款的订单!')
        return 
      }      
      if(this.form.reason==null||this.form.reason==''||this.form.reason==undefined)
      {
        this.$message.error('请选择退款原因!')
        return 
      }  
      this.save();         
    },
    save() {    
      this.loading=true;
      this.elementLoadingText="数据提交中,请稍后..."
      var _this=this;
      this.$refs['form'].validate(async (valid) => {    
        if (valid) { 
          await refund(this.form).then(res=>{       
            _this.loading=false;   
            if(res&&res.data&&res.data.success==true)
            {
              _this.$confirm('申请退款成功，请静待商家审核处理！', '温馨提示',{type:'success'}).then(()=>
              {  
                 _this.$refs['form'].resetFields()
                 _this.$emit('fetch-data')
                 _this.dialogFormVisible = false     
                 _this.form = this.$options.data().form
              });   
            }    
            else
            {
               var msg='申请失败';
               if(res&&res.data&&res.data.error&&res.data.error.message)
               {
                  msg += ',原因:'+res.data.error.message;
               }
               this.$message({ message: msg, type: 'error', customClass: 'c-msg' })
            }
          })
        } else {
          _this.loading=false;
          return false
        }
      })
    },  
 
  },
}
</script>
<style>
.saveBtn
{
  background-color: #FF5E00 !important;
  border-color: #FF5E00 !important;
  color: #FFF !important;
  cursor: pointer !important;
}
.closeBtn
{
  border-color: #FF5E00 !important;
  color:#FF5E00 !important;
  cursor: pointer !important;
}
 .el-dialog__title
{
  font-size: 18px !important;
  color:#FF5E00 !important;
}


.refundReason
{
    width: 100%;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bfcbd9;
    box-sizing: border-box;
    color: #1f2d3d;
    font-size: inherit;
    height: 36px;
    line-height: 1;
    outline: 0;
    padding: 3px 10px;
}
.refundDescription
{
    width: 100%;
    height: 108px;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bfcbd9;
    box-sizing: border-box;
    color: #1f2d3d;
    font-size: inherit;
    line-height: 1.5;
    outline: 0;
    padding: 3px 10px;
}

</style>


// WEBPACK FOOTER //
// OrderRefund.vue?51f33c1b